module.exports = __webpack_public_path__ + "img/adminElevator.0cffdd3a.gif";